import { render, staticRenderFns } from "./ContentPhotoComponent.vue?vue&type=template&id=0caf77b8&scoped=true"
import script from "./ContentPhotoComponent.vue?vue&type=script&lang=js"
export * from "./ContentPhotoComponent.vue?vue&type=script&lang=js"
import style0 from "./ContentPhotoComponent.vue?vue&type=style&index=0&id=0caf77b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf77b8",
  null
  
)

export default component.exports